import React, { Component } from 'react'

class Fade extends Component {
  constructor (props) {
    super(props)
    this.state = {
      show: true,
      animate: false,
      children: null
    }
    this.handleAnimationEnd = this.handleAnimationEnd.bind(this)
  }

  addStyles () {
    return (
      <style
        key='animations'
        dangerouslySetInnerHTML={{
          __html: `
            @keyframes fadeIn {
                0% {
                    opacity: 0;
                }
                100% {
                    opacity: 1;
                }
                }

                @keyframes fadeOut {
                0% {
                    opacity: 1;
                }
                100% {
                    opacity: 0;
                }
            }
            `
        }}
      />
    )
  }

  handleAnimationEnd () {
    const { children } = this.props
    this.setState({ children, show: true })
  }

  static getDerivedStateFromProps (newProps, oldState) {
    if (oldState.children === null) {
      return { children: newProps.children, animate: false, show: true }
    }
    if (
      oldState.children !== newProps.children &&
      document &&
      document.body.style.animation !== undefined // animate only if browser has animation support
    ) {
      return { animate: true, show: false }
    }
    return null
  }

  render () {
    const { show, animate, children: stateChildren } = this.state
    const { children: propsChildren } = this.props

    return [
      this.addStyles(),
      <div
        key='fadeContainer'
        style={
          animate ? { animation: `${show ? 'fadeIn' : 'fadeOut'} .2s` } : {}
        }
        onAnimationEnd={this.handleAnimationEnd}
      >
        {animate && !show ? stateChildren : propsChildren}
      </div>
    ]
  }
}

export default Fade



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/de/fade.jsx